import { Col, Row, Skeleton } from "antd";
import "./opration.scss";
import { useLayout } from "../../layouts/layout";
import { useEffect } from "react";
const OprationResult = ({ isSucess = true, list = [], listclass = "", messageForSuccess = "" }) => {
  const { setLayout } = useLayout();
  useEffect(() => {
    setLayout(
      <div className="print-container-recept">
        <div className="holder-box-result">
          <div className="box">
            <div className="hold-head">
              <div className="icon-head" data-state={isSucess}>
                {isSucess ? <i className="icon-true"></i> : <i className="icon-close"></i>}
              </div>
              <h3>{isSucess ? <>عملیات موفق</> : <>عملیات ناموفق</>}</h3>
            </div>
            <div className="hold-body">
              <ul className={`list-result ${listclass}`}>
                {list.map((item, key) => (
                  <li key={key}>
                    <div className="label">{item.label}</div>
                    <div className="value">{item.value}</div>
                  </li>
                ))}
              </ul>
              {messageForSuccess.length > 0 && (
                <div className="box-message">
                  <p>{messageForSuccess}</p>
                </div>
              )}
              {!isSucess && (
                <div className="box-message">
                  <p>
                    در صورت لزوم با پشتیبانی امور نمایندگان آپتل تماس حاصل فرمایید
                    <br />
                    <span dir="ltr">۰۲۱۷۱۱۱۷۰۷۲</span> - <span dir="ltr">۰۲۱۷۱۱۱۷۰۹۶</span>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>,
    );
  }, [list]);
  return (
    <>
      <Row justify="center" align={"middle"} style={{ height: "100%" }}>
        <Col xl={10} lg={15} md={15} sm={18} xs={24} style={{ margin: "auto" }}>
          <div className="holder-box-result">
            <div className="box">
              <div className="hold-head">
                <div className="icon-head" data-state={isSucess}>
                  {isSucess ? <i className="icon-true"></i> : <i className="icon-close"></i>}
                </div>
                <h3>{isSucess ? <>عملیات موفق</> : <>عملیات ناموفق</>}</h3>
              </div>
              <div className="hold-body">
                <ul className={`list-result ${listclass}`}>
                  {list.map((item, key) => (
                    <li key={key}>
                      <div className="label">{item.label}</div>
                      <div className="value">{item.value}</div>
                    </li>
                  ))}
                </ul>
                {messageForSuccess.length > 0 && (
                  <div className="box-message">
                    <p>{messageForSuccess}</p>
                  </div>
                )}
                {!isSucess && (
                  <div className="box-message">
                    <p>
                      در صورت لزوم با پشتیبانی امور نمایندگان آپتل تماس حاصل فرمایید
                      <br />
                      <span dir="ltr">۰۲۱۷۱۱۱۷۰۷۲</span> - <span dir="ltr">۰۲۱۷۱۱۱۷۰۹۶</span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OprationResult;
